import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Stylesheets/Monthtimeline.css";

// import domain from "../Assets/domain-name.png";
// import assignment from "../Assets/abilities.png";
// import discipline from "../Assets/discipline.png";
import AOS from "aos";

const timelineData = [
  {
    time: "Hands-On Training",
    icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img93365_IMG.png",
    title: "Domain-Specific Hands-On Training",
    description: [
      "Focused sessions in chosen domain (Mobile Apps, Web Apps, Backend Systems).",
      "Real-time coding practice under trainer guidance.",
    ],
    thumbs: [],
    badges: [{ text: "Core Training", color: "primary" }],
  },
  {
    time: "Projects & Exercises",
    icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img98872_IMG.png",
    title: "Dummy Projects and Exercises",
    description: [
      "Practice assignments based on industry use cases.",
      "Trainees simulate real-world tasks to build problem-solving ability.",
    ],
    thumbs: [],
    badges: [{ text: "Practical Learning", color: "success" }],
  },
  {
    time: "Discipline Check",
    icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img72162_IMG.png",
    title: "Discipline Evaluation",
    description: [
      "Continuous observation of teamwork, communication, punctuality, and respect for deadlines.",
      "Weekly feedback is shared with trainees for improvement.",
    ],
    thumbs: [],
    badges: [{ text: "Evaluation", color: "warning text-dark" }],
  },
];

const Month2 = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
    window.scrollTo({ behavior: "smooth", top: 0 });
  }, []);

  return (
    <section
      id="monthtimeline"
      className="min-vh-100 position-relative overflow-hidden"
    >
      {/* Video Background */}
      {/* <div className="home-bg">
        <video loop autoPlay muted playsInline>
          <source src={bg_video} />
        </video>
        <div className="video-overlay"></div>
      </div> */}

      <div className="container text-light position-relative">
        <h1 className="text-center gradient-text mt-5 py-3 fw-bold monthtimeline" style={{fontFamily:"'Merriweather', serif"}}>
         Core Training
        </h1>
        <div className="timeline">
          {timelineData.map((item, index) => (
            <div className="timeline-row" data-aos="fade-up" key={index}>
              {item.loading ? (
                <div className="timeline-content" data-aos="fade-down">
                  <p className="m-0">Loading...</p>
                </div>
              ) : (
                <>
                  <div
                    className="timeline-time text-light fw-bold"
                    data-aos="zoom-in-up"
                  >
                    {item.time}
                  </div>
                  <div className="timeline-content">
                    <img
                      src={item.icon}
                      alt={item.title}
                      className="timeline-icon"
                    />
                    <h4 style={{color:" rgb(7, 223, 252)"}}>{item.title}</h4>

                    {/* Description as <ul> */}
                    <ul>
                      {item.description.map((point, i) => (
                        <li key={i}>{point}</li>
                      ))}
                    </ul>

                    <div>
                      {item.badges.map((badge, i) => (
                        <span
                          key={i}
                          className={`badge rounded-pill bg-${badge.color} ${
                            i > 0 ? "ms-1" : ""
                          }`}
                        >
                          {badge.text}
                        </span>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Month2;
